<template>
  <a-row type="flex" style="margin-top: 20px">
    <a-col flex="300px">
      <div
        v-for="(item, index) in cardList"
        :key="index"
        class="card-item"
        @click="toggleCard(item, index)"
        :class="{ 'card-active': currCardId === item.id }"
      >
        <div class="card-title">{{ item.title }}</div>
        <div>
          活动日期：{{ classDetail.beginDate || viewRecord.beginDate }} 至
          {{ classDetail.endDate || viewRecord.endDate }}
        </div>
      </div>
    </a-col>
    <a-col flex="2px">
      <a-divider type="vertical" style="height: 600px" />
    </a-col>
    <a-col flex="auto">
      <a-tabs :activeKey="currTabKey" @change="changeTab">
        <a-tab-pane
          v-for="(item, index) in tabList"
          :key="item.key"
          :tab="`${item.tab}(${tabList[index]?.num || 0})`"
        >
          <TableList
            style="width: 100%; margin-top: 10px"
            :columns="columns"
            :tableData="dataSource"
            :loading="loading"
            :scroll="{}"
            :pagination="ipagination"
            @change="handleTableChange"
          >
            <template #action="{ record }">
              <span style="color: #1783e8; cursor: pointer" @click="viewReport(record)">
                查看报告
              </span>
            </template>
          </TableList>
        </a-tab-pane>
        <a-button type="primary" slot="tabBarExtraContent" @click="exportXls">导出</a-button>
      </a-tabs>
    </a-col>
    <!--数据报告-->
    <DetailedReport ref="detailedReportRef" />
  </a-row>
</template>

<script>
import TableList from '@comp/chart/TableList.vue'
import { getAction } from '@api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DetailedReport from '@/comUi/ArchivesView/components/DetailedReport.vue'

export default {
  name: 'ClassCompleteDetail',
  components: {
    DetailedReport,
    TableList,
  },
  mixins: [JeecgListMixin],
  props: {
    viewRecord: {
      type: Object,
      default: () => ({}),
    },
    classDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currCardId: '',
      currTabKey: '0',
      cardList: [{}, {}],
      tabList: [
        {
          tab: '待完成',
          key: '0',
        },
        {
          tab: '已完成',
          key: '1',
        },
      ],
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '姓名',
          dataIndex: 'studentName',
          align: 'center',
        },
        {
          title: '开始时间',
          dataIndex: 'createTime',
          align: 'center',
          // customRender: (_, record) => {
          //   return record.createTime ? moment(record.createTime).format('YYYY-MM-DD') : ''
          // },
        },
        {
          title: '用时（秒）',
          dataIndex: 'speedTime',
          align: 'center',
        },
        {
          title: '测评分数',
          dataIndex: 'score',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      tableData: [],
      loading: false,
      disableMixinCreated: true,
      url: {
        list: '/schoolEvaluationRecord/list',
        exportXlsUrl: '/schoolEvaluationRecord/exportXls',
      },
      // pagination: {
      //   current: 1,
      //   pageSize: 10,
      //   pageSizeOptions: ['10', '20', '50'],
      //   showTotal: (total, range) => {
      //     return range[0] + '-' + range[1] + ' 共' + total + '条'
      //   },
      //   // showQuickJumper: true,
      //   showSizeChanger: true,
      //   total: 0,
      // },
    }
  },
  created() {
    console.log('classDetail', this.classDetail)
    this.$set(this.queryParam, 'classId', this.classDetail.classId)
    this.getEvaluationByPlanId()
  },
  methods: {
    async getFinishNum() {
      this.tabList.forEach((item, index) => {
        getAction('/schoolEvaluationRecord/list', {
          ...this.queryParam,
          status: item.key,
          classId: this.classDetail.classId,
        }).then((res) => {
          this.$set(this.tabList[index], 'num', res.result.total)
        })
      })
    },
    async getEvaluationByPlanId() {
      const res = await getAction('/schoolEvaluationPlan/getEvaluationByPlanId', {
        planId: this.viewRecord.id,
        classId: this.classDetail.classId,
      })
      if (res.success) {
        this.cardList = res.result.map((item) => ({
          ...item,
          title: item.name,
          timeRange: `${item.createTime}`,
        }))
        console.log('卡片列表：', this.cardList)
        this.currCardId = this.cardList[0].id
        this.queryParam = {
          ...this.queryParam,
          planId: this.viewRecord.id,
          evaluationId: this.currCardId,
          status: this.currTabKey,
        }
        this.loadData()
        this.getFinishNum()
      }
      console.log('量表列表', res)
    },
    toggleCard(item, index) {
      this.currCardId = item.id
      this.$set(this.queryParam, 'evaluationId', item.id)
      this.getFinishNum()
      this.loadData()
    },
    changeTab(key) {
      console.log(key)
      this.currTabKey = key
      this.$set(this.queryParam, 'status', this.currTabKey)
      this.loadData()
    },
    viewReport(record) {
      console.log('查看数据报告：', record)
      this.$refs.detailedReportRef.showModal(record)
    },
    exportXls() {
      console.log('参数：', this.queryParam)
      const { planId, evaluationId, classId } = this.queryParam
      this.handleExportXls('量表完成情况', { planId, evaluationId, classId })
    },
  },
}
</script>
<style scoped lang="less">
.card-item {
  padding: 15px 10px 20px;
  margin-bottom: 15px;
  margin-right: 10px;
  border: 1px solid #86bff4;
  border-radius: 8px;
  cursor: pointer;

  .card-title {
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: bold;
  }
}

@keyframes cardFadeIn {
  from {
    opacity: 0;
    background-color: #ffffff;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    background-color: #eaf5ff;
    transform: scale(1);
  }
}

.card-active {
  background-color: #eaf5ff;
  animation: cardFadeIn 0.3s ease-in-out;
}
</style>
